const testimonials = [
  { name: "Dr. Sarah M., DVM Candidate", location: "Auburn University, Auburn, AL", rating: 5, text: "I was accepted into a One Health research program in Kenya with six weeks notice. My passport had been expired for two years — I had no idea how to get it renewed that fast. Fast Passport Center walked me through everything, reviewed my documents, and had my renewed passport back in seven business days. I made my departure from Atlanta and completed my full research rotation. I am genuinely not sure I could have gone without them.", service: "Expedited Renewal" },
  { name: "Professor James K.", location: "Auburn University College of Engineering", rating: 5, text: "I submitted an abstract to an IEEE conference in Munich in September and did not realize my passport expired until my registration was confirmed in February. The conference was in April. Fast Passport Center turned around my renewal in five business days. I presented my paper, met collaborators from three countries, and came home with two new research partnerships. Will absolutely use them again.", service: "Passport Renewal" },
  { name: "Marcus &amp; Emily T.", location: "Opelika, AL", rating: 5, text: "Our son was accepted to an AU engineering co-op in Germany starting in May. We did not check his passport until March — it had expired. Panic. Fast Passport Center had his new passport processed in six business days. He arrived on time, completed his full co-op rotation, and came back with a job offer. Worth every cent. Thank you.", service: "Emergency Renewal" },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function AuburnTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Auburn &amp; Lee County Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Auburn University students, faculty, and East Alabama residents who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col">
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic" dangerouslySetInnerHTML={{ __html: `&ldquo;${t.text}&rdquo;` }}></p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm" dangerouslySetInnerHTML={{ __html: t.name }}></p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">{t.service}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}